(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["page-loader"] && !Shopify.designMode) return;
  try {
    (function() {
    const pageLoader = document.getElementById('page-loader');
    if (!pageLoader) return;

    // Hide loader when page is fully loaded
    if (document.readyState === 'complete') {
      setTimeout(() => {
        pageLoader.classList.add('page-loader--hidden');
      }, 500);
    } else {
      window.addEventListener('load', () => {
        setTimeout(() => {
          pageLoader.classList.add('page-loader--hidden');
        }, 500);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
